//! not used
export enum EnumCampaignStatusType {
  DRAFT = 0,
  READY = 1,
  RUNNING = 2,
  PAUSED = 3,
  ARCHIVED = 4,
  COMPLETED = 5,
  WARNING = 6,
  ERROR = 7,
}
export const campaignStatusType = {
  [EnumCampaignStatusType.DRAFT]: 'Draft',
  [EnumCampaignStatusType.READY]: 'Ready',
  [EnumCampaignStatusType.RUNNING]: 'Running',
  [EnumCampaignStatusType.PAUSED]: 'Paused',
  [EnumCampaignStatusType.ARCHIVED]: 'Archived',
  [EnumCampaignStatusType.COMPLETED]: 'Completed',
  [EnumCampaignStatusType.WARNING]: 'Warning',
  [EnumCampaignStatusType.ERROR]: 'Error',
}
export enum EnumCampaignType {
  STANDARD = 1,
  AUTOPROMO = 2,
  PSA = 3,
  FILLERS = 4,
  VIDEO = 5,
  OUTOFNETWORK = 6,
  PGAUDIO = 7,
  PGVIDEO = 8,
  BACKFILL = 9,
  PMPAUDIO = 10,
  PMPVIDEO = 11,
}
export const optionsCampaignTypes = {
  [EnumCampaignType.STANDARD]: 'Standard',
  [EnumCampaignType.AUTOPROMO]: 'AutoPromo',
  [EnumCampaignType.PSA]: 'Psa',
  [EnumCampaignType.FILLERS]: 'Fillers',
  [EnumCampaignType.VIDEO]: 'Video',
  [EnumCampaignType.OUTOFNETWORK]: 'Out of Network',
  [EnumCampaignType.PGAUDIO]: 'PG Audio',
  [EnumCampaignType.PGVIDEO]: 'PG Video',
  [EnumCampaignType.BACKFILL]: 'Backfill',
  [EnumCampaignType.PMPAUDIO]: 'PMP Audio',
  [EnumCampaignType.PMPVIDEO]: 'PMP Video',
}
